<template>
    <input
        ref="inputRef"
        type="tel"
        :required="required"
        :placeholder="placeholder"
    />
</template>

<script>
import { useCurrencyInput } from 'vue-currency-input';
export default {
    name: "CurrencyInput",
    props: {
        modelValue: Number,
        options: Object,
        required: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const { inputRef } = useCurrencyInput({
            currency: 'BRL',
            locale: 'pt-BR',
            hideCurrencySymbolOnFocus: false,
            hideGroupingSeparatorOnFocus: false,
            ...props.options,
        })

        return { inputRef }
    },
};
</script>

<style scoped>

</style>
